module.exports = __webpack_public_path__ + "img/carnival-cowboys-splash.8c885245.png";